import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "12",
  fill: "none",
  viewBox: "0 0 8 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M-8186.7 8.5h16383M6.9 4 4 6.9 1.1 4C1 3.9.8 3.8.6 3.8s-.3 0-.5.2c-.1.1-.2.3-.2.5s0 .3.2.5l3.3 3.3s.1.1.2.1h.6s.2 0 .2-.1L7.7 5s.1-.1.1-.2v-.6s0-.2-.1-.2c0 0-.1-.1-.2-.1h-.6s-.2 0-.2.1Z"
    }, null, -1)
  ]))]))
}
export default { render: render }